import { TIMEOUT } from '@constants/components/timeout';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Element } from 'react-scroll';
import { ListOrganization } from './list';

const AziendaOrganizzazioneMobile = () => {
  const intl = useIntl();
  useEffect(() => {
    setTimeout(() => {
      const { hash } = window.location;
      window.location.hash = '';
      window.location.hash = hash;
    }, TIMEOUT);
  }, []);
  return (
    <div
      className="snf-lx-components-azienda-organizzazione-mobile-mobile"
      style={{ display: 'contents' }}
    >
      <Element name="organization">
        <div className={cn('div-image', `snf-bg-repeat-no-repeat`)} id="organization">
          <div className="container-fluid snf-text-color-black p-2 ">
            <div className="row  ml-1 mb-2">
              <div className="col-auto snf-font-32 snf-font-w6 mb-3 ">
                {intl.formatMessage({
                  defaultMessage: "L'organizzazione"
                })}
              </div>
            </div>

            <div className="row ml-1 mb-3">
              <div className="col-12  snf-font-24">
                {intl.formatMessage(
                  {
                    defaultMessage: '<strong>Una struttura a matrice</strong>'
                  },
                  {
                    strong: (chunks) => <strong>{chunks}</strong>
                  }
                )}
              </div>
            </div>
            <div className="row mx-1 mb-4">
              <div className="col-12  snf-font-16">
                {intl.formatMessage(
                  {
                    defaultMessage:
                      'L’organizzazione di Sistemi Informativi è strutturata per rispondere in modo reattivo e coerente alle innovazioni del mercato IT e ai trend di trasformazione tecnologica, per assicurare una <strong>gestione strutturata</strong> dei processi ed un <strong>monitoraggio adeguato</strong> di tutte le attività aziendali, in conformità alle policy del gruppo IBM e ai requisiti di qualità attesi.'
                  },
                  {
                    strong: (chunks) => <strong>{chunks}</strong>
                  }
                )}
              </div>
            </div>

            <div className="row ml-1 mb-3">
              <div className="col-12  snf-font-24">
                {intl.formatMessage(
                  {
                    defaultMessage: '<strong>Dimensioni e Strutture</strong>'
                  },
                  {
                    strong: (chunks) => <strong>{chunks}</strong>
                  }
                )}
              </div>
            </div>
            <div className="row mx-1 mb-5">
              <div className="col-12  snf-font-16">
                {intl.formatMessage(
                  {
                    defaultMessage:
                      'L’organizzazione definita a "matrice", che ci consente di condividere le risorse fra Team di Progetto, è costituita dalla <strong>dimensione orizzontale</strong>, ovvero l’insieme dei nostri <strong>servizi</strong> e delle nostre <strong>soluzioni</strong>, e dalla <strong>dimensione verticale</strong>, che include settori di mercato in cui operiamo, ovvero il <strong>Public</strong>, il <strong>Banking</strong> e l’<strong>Insurance</strong>.'
                  },
                  {
                    strong: (chunks) => <strong>{chunks}</strong>
                  }
                )}
              </div>
            </div>

            <div className="row mb-5 snf-font-12 justify-content-around text-center">
              <div className="col-6 mb-3">
                <div className="row mb-2 no-gutters justify-content-center">
                  <div className="col-auto">
                    <Link to="/settori-industria#Public">
                      <img
                        src="/images/organization-public.svg"
                        width="100"
                        height="auto"
                        alt="Logo Public"
                      />
                    </Link>
                  </div>
                </div>
                <div className="row no-gutters justify-content-center">
                  <div className="col-auto">
                    {intl.formatMessage(
                      {
                        defaultMessage: '<strong>PUBLIC</strong>'
                      },
                      {
                        strong: (chunks) => <strong>{chunks}</strong>
                      }
                    )}
                  </div>
                </div>
              </div>
              <div className="col-6 mb-3">
                <div className="row mb-2 no-gutters justify-content-center">
                  <div className="col-auto">
                    <Link to="/settori-industria#Banking">
                      <img
                        src="/images/organization-banche.svg"
                        width="100"
                        height="auto"
                        alt="Logo Banca"
                      />
                    </Link>
                  </div>
                </div>
                <div className="row no-gutters justify-content-center">
                  <div className="col-auto">
                    {intl.formatMessage(
                      {
                        defaultMessage: '<strong>BANKING</strong>'
                      },
                      {
                        strong: (chunks) => <strong>{chunks}</strong>
                      }
                    )}
                  </div>
                </div>
              </div>

              <div className="col-6 mb-3">
                <div className="row mb-2 no-gutters justify-content-center">
                  <div className="col-auto">
                    <Link to="/settori-industria#Insurance">
                      <img
                        src="/images/organization-scudo.svg"
                        width="100"
                        height="auto"
                        alt="Logo Scudo"
                      />
                    </Link>
                  </div>
                </div>
                <div className="row no-gutters justify-content-center">
                  <div className="col-auto">
                    {intl.formatMessage(
                      {
                        defaultMessage: '<strong>INSURANCE</strong>'
                      },
                      {
                        strong: (chunks) => <strong>{chunks}</strong>
                      }
                    )}
                  </div>
                </div>
              </div>
            </div>
            <ListOrganization />
          </div>
        </div>
      </Element>
    </div>
  );
};

AziendaOrganizzazioneMobile.displayName = "L'Azienda Storia Mobile ";
export { AziendaOrganizzazioneMobile };
